import Vue from 'vue';

import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      reportBlock: {},
      reportBlockEditId: null,
      editReportBlockDescriptor: false,
      editReportBlockIndex: false,
      showCreateReportBlockModal: false,
      createReportBlockInputs: { conditions: {}, },
    },
    getters: {

    },
    actions: {
      async getReportBlock({ commit, dispatch, }, { id, params, }) {
        commit('setError', {});
        commit('setReportBlock', {});
        const actionId = await dispatch('addPendingAction');
        commit('setEditReportBlockDescriptor', false);
        commit('setEditReportBlockIndex', false);

        try {
          const result = await app.service('report-blocks').get(id, params);
          commit('setReportBlock', result);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async updateReportBlockContent({ state, dispatch, commit, }, content) {
        if (!state.reportBlock || !state.reportBlock.reportBlockContentId) {
          throw new Error('Invalid reportBlock in state');
        }

        const id = state.reportBlock.reportBlockContentId;

        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          await app.service('report-block-content').patch(id, { content, });
          commit('setReportBlockEditId', null);
          await dispatch('getReportBlock', { id: state.reportBlock.id, });
          commit('setReportBlockEditId', state.reportBlock.id);
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async patchReportBlock({ commit, dispatch, state, }, data) {
        const id = state.reportBlock.id;
        if (!id) {
          throw new Error('Invalid reportBlock in state');
        }

        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          await app.service('report-blocks').patch(id, data);
          await dispatch('getReportBlock', { id, });
          if (state.reportTypeDetails.id) {
            await dispatch('getReportTypeDetails', { id: state.reportTypeDetails.id, });
          }
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async removeReportBlock({ commit, dispatch, state, }, id) {
        if (state.reportBlockEditId === id) {
          commit('setReportBlockEditId', null);
        }

        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          await app.service('report-blocks').remove(id);
          await dispatch('getReportTypeDetails', { id: state.reportTypeDetails.id, });
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async createReportBlock({ commit, dispatch, state, }) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const { id: reportTypeId, } = state.reportTypeDetails;

          if (!reportTypeId) {
            throw new Error('Invalid archetype id. Please reload and try again.');
          }

          const { index, descriptor, conditions, } = state.createReportBlockInputs;

          if (!index || !descriptor) {
            throw new Error('Missing index or descriptor');
          }

          const result = await app.service('report-blocks').create({ index: index - 1, descriptor, conditions, reportTypeId, });
          commit('setShowCreateReportBlockModal', false);

          commit('setCreateReportBlockIndex', undefined);
          commit('setCreateReportBlockDescriptor', undefined);
          commit('setCreateReportBlockConditions', {});

          await dispatch('getReportTypeDetails', { id: state.reportTypeDetails.id, });
          await dispatch('getReportBlock', { id: result.id, });
          commit('setReportBlockEditId', result.id);
          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },
    },
    mutations: {
      setReportBlock: (state, reportBlock) => state.reportBlock = reportBlock,
      setReportBlockEditId: (state, reportBlockEditId) => state.reportBlockEditId = reportBlockEditId,
      setEditReportBlockDescriptor: (state, editReportBlockDescriptor) => state.editReportBlockDescriptor = editReportBlockDescriptor,
      setEditReportBlockIndex: (state, editReportBlockIndex) => state.editReportBlockIndex = editReportBlockIndex,
      setShowCreateReportBlockModal: (state, showCreateReportBlockModal) => state.showCreateReportBlockModal = showCreateReportBlockModal,

      clearCreateReportBlockInputs: state => state.createReportBlockInputs = { conditions: {}, },
      setCreateReportBlockIndex: (state, index) => Vue.set(state.createReportBlockInputs, 'index', index),
      setCreateReportBlockDescriptor: (state, descriptor) => Vue.set(state.createReportBlockInputs, 'descriptor', descriptor),
      setCreateReportBlockConditions: (state, conditions) => Vue.set(state.createReportBlockInputs, 'conditions', conditions),
    },
  };
}
